// extracted by mini-css-extract-plugin
export default {"FooterLeftItem":"FooterLeftItem_FooterLeftItem__OGo0O","FooterLeftItemText":"FooterLeftItem_FooterLeftItemText__EKd5N"};